module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAgCAMAAACMyGAQAAAAM1BMVEUAAAD///////////////////////////////////////////////////////////////+3leKCAAAAEHRSTlMAQIC/7xAg33CfYDDPr49Q8KlyxwAAAP5JREFUOMuVlFsOhCAMRVveokL3v9oxPFJnGCqeH03wUFJ6hS8QlVKIsEg8qaOjhUeCoTsmgIw76JdDLLMbGtFvBbMLR+rCli2AzfrxULqdwkEDPWlJiK0AMHbsFKqLtqdnQUDRBd5KeFg36k3jC8NwiTVjLyUSr1QCVkrL6A5geUTo0DdxZuDMUKMRXhtYF0RDX/gyOtdLM86ZEcZeWSrwTDVaIHEwpkPiq2H/GIkK+SfE1IdnNBwHaMxY4hD1++R4mMgC9oy5/5mlhsa23UaNUxiyij+V2g6OupNjOxJghj1oRI6l3WgkLf1EGZPhAavujlEWFshJl691kvb/AAYZI1G0MrPrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-plus.png
// module id = 28
// module chunks = 1